import ApplicationPromoSentComponent from "src/components/StoresPromosComponent/ApplicationPromoSentComponent";

export default function ApplicationPromoSent() {
  return (
    <ApplicationPromoSentComponent />
  )
}